<template>
    <b-modal id="triggerInfoModal" title="Informações Resumidas - Ocorrências" hide-footer size="lg">
        <div v-if="triggerData" class="trigger-info">
            <div class="info-section info-grid mb-3">
                <div class="info-row">
                    <span class="info-label">Aberta em:</span>
                    <span class="info-value">{{ triggerData.creationDate }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Processo:</span>
                    <span class="info-value">{{ triggerData.process }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Responsável:</span>
                    <span class="info-value">{{ triggerData.responsible }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Turno:</span>
                    <span class="info-value">{{ triggerData.workshift }}</span>
                </div>
            </div>

            <hr class="separator">

            <div class="info-section">
                <div class="info-row">
                    <span class="info-label">Status:</span>
                    <span class="info-value">{{ triggerData.record }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Motivo:</span>
                    <span class="info-value">{{ triggerData.motivo || '-' }}</span>
                </div>
            </div>
        </div>

        <div class="mt-3 d-flex justify-content-end">
            <b-button variant="secondary" @click="fechar">
                Fechar
            </b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "TriggerInfoModal",
    props: {
        triggerData: {
            type: Object,
            default: null
        }
    },
    methods: {
        fechar() {
            this.$bvModal.hide('triggerInfoModal');
        }
    }
};
</script>

<style scoped>
.trigger-info {
    font-size: 0.95rem;
    max-height: 400px;
    overflow-y: auto;
    padding-right: 0.5rem;
}

.info-section {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
}

.info-row {
    display: flex;
    flex-direction: column;
}

.info-label {
    font-weight: 600;
    margin-bottom: 0.25rem;
}

.info-value {
    color: #333;
    word-break: break-word;
}

.separator {
    border: none;
    border-top: 2px solid #000000;
    margin: 1rem 0;
}

.trigger-info::-webkit-scrollbar {
    width: 8px;
}

.trigger-info::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.trigger-info::-webkit-scrollbar-thumb {
    background: #004747;
    border-radius: 4px;
}

.trigger-info::-webkit-scrollbar-thumb:hover {
    background: #003333;
}
</style>
